import Vue from 'vue'
import VueRouter from 'vue-router'
import MainLayout from "@/views/MainLayout";
import DashBoard from "@/views/agent/DashBoard";
import LoginView from "@/views/LoginView";
import store from "@/store"

Vue.use(VueRouter)

// Role groups
const ALL_ROLES   = ['user', 'local_government', 'government', 'admin']
const GOV_OR_ABOVE = ['local_government', 'government', 'admin']
const GOV_NATIONAL = ['government', 'admin']
const ISSUER_ONLY  = ['user', 'admin']

const routes = [
  { path: '/', redirect: 'login' },

  // Dashboard — every authenticated role gets a (scoped) dashboard
  {
    path: '/home',
    name: 'home',
    meta: { layout: MainLayout, auth: true, roles: ALL_ROLES },
    component: DashBoard,
  },
  {
    path: '/access-denied',
    name: 'access-denied',
    meta: { layout: MainLayout, auth: true, roles: ALL_ROLES },
    component: () => import('@/views/accessDenied')
  },

  // Policy issuance — only user + admin
  {
    path: '/travel',
    name: 'travel',
    meta: { layout: MainLayout, auth: true, roles: ISSUER_ONLY },
    component: () => import('@/views/agent/createPolicy'),
  },
  {
    path: '/motor',
    name: 'motor',
    meta: { layout: MainLayout, auth: true, roles: ISSUER_ONLY },
    component: () => import('@/views/agent/createMotor'),
  },

  // Profile — every role
  {
    path: '/user',
    name: 'user',
    meta: { layout: MainLayout, auth: true, roles: ALL_ROLES },
    component: () => import('@/views/agent/userView'),
  },

  // Search & Reports — every role (scoping happens server-side)
  {
    path: '/travel-search',
    name: 'travel-search',
    meta: { layout: MainLayout, auth: true, roles: ALL_ROLES },
    component: () => import('@/views/agent/searchView'),
  },
  {
    path: '/motor-search',
    name: 'motor-search',
    meta: { layout: MainLayout, auth: true, roles: ALL_ROLES },
    component: () => import('@/views/agent/searchMotor'),
  },
  {
    path: '/travel-report',
    name: 'travel-report',
    meta: { layout: MainLayout, auth: true, roles: ALL_ROLES },
    component: () => import('@/views/agent/reportView'),
  },
  {
    path: '/motor-report',
    name: 'motor-report',
    meta: { layout: MainLayout, auth: true, roles: ALL_ROLES },
    component: () => import('@/views/agent/reportMotor'),
  },

  // Claims — list & detail open to every role (scoped); submission restricted
  {
    path: '/claim',
    name: 'claim-list',
    meta: { layout: MainLayout, auth: true, roles: ALL_ROLES },
    component: () => import('@/views/agent/claim/listView'),
  },
  {
    path: '/claim/new',
    name: 'claim-new',
    meta: { layout: MainLayout, auth: true, roles: ISSUER_ONLY },
    component: () => import('@/views/agent/claim/createView'),
  },
  {
    path: '/claim/detail/:id',
    name: 'claim-detail',
    meta: { layout: MainLayout, auth: true, roles: ALL_ROLES },
    component: () => import('@/views/agent/claim/detailView'),
  },

  // ───── Refunds ─────
  {
    path: '/refund',
    name: 'refund-list',
    meta: { layout: MainLayout, auth: true, roles: ALL_ROLES },
    component: () => import('@/views/agent/refund/listView'),
  },
  {
    path: '/refund/new',
    name: 'refund-new',
    meta: { layout: MainLayout, auth: true, roles: ISSUER_ONLY },
    component: () => import('@/views/agent/refund/createView'),
  },
  {
    path: '/refund/detail/:id',
    name: 'refund-detail',
    meta: { layout: MainLayout, auth: true, roles: ALL_ROLES },
    component: () => import('@/views/agent/refund/detailView'),
  },

  { path: '/login', name: 'login', component: LoginView },
]

// Keep ALL_ROLES exported for use elsewhere if needed
export { ALL_ROLES, GOV_OR_ABOVE, GOV_NATIONAL, ISSUER_ONLY }

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    if (!store.getters.isLoggedIn) {
      return next('/login')
    }
    const role = store.getters.userRole

    // Admin bypasses all role checks
    if (role === 'admin') return next()

    // Determine allowed roles for this route
    const allowed = to.meta.roles || (to.meta.role ? [to.meta.role] : null)
    if (!allowed || allowed.includes(role)) return next()

    return next('/access-denied')
  }
  next()
})

export default router
